export default function getInitPersonalised(listingPageSearchQuery, routerQuery, productsRented) {
  let initCheckedPersonalised = "all";
  let initFiltersConfigure = "";

  if (productsRented?.length && (listingPageSearchQuery?.includes("personalised[]=not_rented") || routerQuery?.["personalised[]"] === "not_rented")) {
    initCheckedPersonalised = "not_rented";
    initFiltersConfigure = `NOT ${productsRented?.map((id) => `id:${id}`).join(" AND NOT ")}`;
  } else if (listingPageSearchQuery?.includes("personalised[]=rented") || routerQuery?.["personalised[]"] === "rented") {
    initCheckedPersonalised = "rented";
    if (productsRented?.length) {
      initFiltersConfigure = productsRented?.map((id) => `id:${id}`).join(" OR ");
    } else {
      initFiltersConfigure = "id:NO_RENTED_PRODUCTS_EXCEPTION";
    }
  }

  return { initCheckedPersonalised, initFiltersConfigure };
}
